<template>
  <section>
    <div class="dashboard-container flex flex-wrap flex-col">
      <SmartRow>
        <SmartTitle class="form-list__title mb-2 mt-2" heading="1">Exportar Bases</SmartTitle>
      </SmartRow>
      <SmartRow>
        <SmartButtonDash
          v-for="service in items"
          :key="service.title"
          v-bind="service"
          :action="service.action"
          @click.native="changeRoute(service.name)"
          class="lg:col-4 md:col-12 sm:col-12 flex flex-wrap"
        />
      </SmartRow>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ExportarBases',
  data() {
    return {
      services: [
        {
          title: 'Chip',
          description: 'Identifique o total de PDVS e seus responsáveis.',
          buttonText: 'Exportar',
          name: 'exportChip',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Recargas',
          description: 'Saiba quem são os usuários ativos e inativos do Smart.',
          buttonText: 'Exportar',
          name: 'exportRecharge',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Capilaridade',
          description:
            'Saiba quais são os PDVS criados pela funcionalidade de "usar minha localização".',
          buttonText: 'Exportar',
          name: 'exportCapillarity',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Bipagem',
          description: 'Exporte os dados de bipagem em lotes e chips.',
          buttonText: 'Exportar',
          name: 'exportBeep',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Ativações Duplicadas',
          description: 'Exporte os dados de ativações duplicadas.',
          buttonText: 'Exportar',
          name: 'exportDuplicateActivation',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Histórico de Importação',
          description: 'Relatório que demonstra todos os status de importação de arquivos pelo TIM Smart (Faturamento de Chip / Recarga), seja esse status positivo e negativo.',
          buttonText: 'Exportar',
          name: 'exportImportHistory',
          permission: 'web.exportarbases.listar'
        },
        {
          title: 'Estoque - Movimentação de Chip',
          description: 'Exporte os dados de movimentação de chip.',
          buttonText: 'Exportar',
          name: 'exportChipMovimentation',
          permission: 'web.exportarbases.listar.em.desenvolvimento'
        },
      ]
    };
  },
  methods: {
    changeRoute(routerName) {
      this.$router.push({ name: routerName });
    }
  },
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission'
    }),
    items() {
      return this.services.filter(item =>
        this.webPermission.find(p => p.name === item.permission)
      );
    },
  },
};
</script>

<style scoped>
</style>

<style lang="scss">
</style>
